import component from './sessionsLog.vue'

export default component
